module.exports = __webpack_public_path__ + "static/dinosaur3-21c7138d7b848043941927df77212ad4.png";